export enum IconType {
    WebSvg = 'icon_type_svg_web',
    WebImg = 'icon_type_img_web',
    AntdMobile = 'icon_type_antd_Mobile_local',
    Antd = 'icon_type_antd_local',
}
